
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule} from '@angular/forms'
import {RouterModule} from "@angular/router";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatButtonModule} from "@angular/material/button";
import {MatSelectModule} from "@angular/material/select";
import {FuseSidebarModule} from "../../../@fuse/components";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {VoucherTemplateComponent} from "./voucherTemplate.component";
import {VoucherTemplateMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {TranslateModule} from "@ngx-translate/core";
import {VoucherTemplateFormComponent} from "./voucherTemplateForm.component";
import {SecurityModule} from "../security/security.module";
import {MatTabsModule} from "@angular/material/tabs";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MomentDateAdapter, MomentDateModule} from "@angular/material-moment-adapter";
import {DateAdapter} from "angular-calendar";
import {GalleryModule} from "../cms/gallery/gallery.module";
import {DeleteVoucherTemplateDialogComponent} from "./dialog/deleteVoucherTemplateDialog.component";
import {MatToolbarModule} from "@angular/material/toolbar";
import {HelpersModule} from "../helpers/helpers.module";
import {VoucherTemplateSortingComponent} from "./voucherTemplateSorting.component";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {FirstTimeConfirmationDialogComponent} from "./dialog/firstTimeConfirmation.component";
import {SecondTimeConfirmationDialogComponent} from "./dialog/secondTimeConfirmation.component";

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'DD-MM-YYYY',
    },
    display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'MMMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    },
};

@NgModule({
    declarations: [
        VoucherTemplateComponent,
        VoucherTemplateMainSidebarComponent,
        VoucherTemplateFormComponent,
        DeleteVoucherTemplateDialogComponent,
        VoucherTemplateSortingComponent,
        FirstTimeConfirmationDialogComponent,
        SecondTimeConfirmationDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        FlexLayoutModule,
        MatSelectModule,
        MatCheckboxModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        TranslateModule,
        SecurityModule,
        MatTabsModule,
        MatInputModule,
        MatDatepickerModule,
        MomentDateModule,
        GalleryModule,
        MatToolbarModule,
        HelpersModule,
        DragDropModule

    ],
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
    exports: [
        VoucherTemplateMainSidebarComponent
    ],
    bootstrap: [
        VoucherTemplateComponent,
        VoucherTemplateFormComponent,
        VoucherTemplateSortingComponent,
    ]
})
export class VoucherTemplateModule { }
